import { Link } from 'react-router-dom';
import type { RegistryToolResponse } from '../types/api';
import { InstallCmd } from './InstallCmd';
import { TypeBadge } from './TypeBadge';

interface ToolCardProps {
  tool: RegistryToolResponse;
}

export function ToolCard({ tool }: ToolCardProps) {
  return (
    <div className="rounded-xl bg-surface p-4 shadow flex flex-col gap-2">
      <div className="flex items-center gap-2 flex-wrap">
        <Link
          to={`/registry/${tool.slug}`}
          className="font-semibold text-white hover:text-secondary transition-colors"
        >
          {tool.name}
        </Link>
        <TypeBadge type={tool.type} />
        {tool.verified && (
          <span className="text-xs text-secondary font-medium" aria-label="Verified">
            ✓ Verified
          </span>
        )}
      </div>

      {tool.description && (
        <p className="text-sm text-gray-400 line-clamp-2">{tool.description}</p>
      )}

      <InstallCmd cmd={tool.install_cmd} />

      <div className="text-xs text-gray-500">
        {tool.weekly_downloads.toLocaleString()} downloads / week
      </div>
    </div>
  );
}
